import { isNil } from 'lodash-es'
import { DateTime } from 'luxon'

import { CancellationConfig, ProductConfig } from '../state/configuration'
import { hasPolicyEnded, isPolicyTerminated } from './policy'
import { Policy } from './types'

export const isCancellationReasonInvalid = (
  reasons: string[] | undefined,
  reason: string | null,
): boolean => !isNil(reasons) && isNil(reason)

export const showCancel = (policy: Policy, { cancellation }: ProductConfig) =>
  !hasPolicyEnded(policy) && Boolean(cancellation)

export const canCancel = (
  policy: Policy,
  config: CancellationConfig | undefined,
): config is CancellationConfig => {
  const isPolicyInCorrectState = !isPolicyTerminated(policy) && !hasPolicyEnded(policy)

  const hasNotEnded = !hasPolicyEnded(policy)

  const doesConfigAllowCancellation = (() => {
    switch (config?.type) {
      case 'CoolingOff': {
        const isWithinCoolingOffPeriod = policy.policyDetail.activatedAt
          ? DateTime.local() <
            DateTime.fromISO(policy.policyDetail.activatedAt)
              .plus({ day: config.days + 1 })
              .startOf('day')
          : true

        return isWithinCoolingOffPeriod && hasNotEnded
      }
      case 'Standard':
        return hasNotEnded
      default:
        return false
    }
  })()

  return isPolicyInCorrectState && doesConfigAllowCancellation
}
